import React, { useState } from 'react';
import BookMeeting from '@ajat/design-system/BookMeeting';
import Button from '@ajat/design-system/Button';
import { ComponentPage, DemoCard } from '../../shared';

const COPY = {
  title: 'Mangler du og din klasse hjælp til jeres studieturstøj?',
  infoText:
    'At stå for klassens studieturstøj kan være en stor opgave. Men bare rolig, vi er her for at hjælp jer. Hvert år hjælper vi tusindvis af studerende og vi sidder naturligvis også klar til at hjælp jer. Udfyld formularen herunder, vælg den tid og dato der passer jer, så sidder vi klar til at hjælp jer.',
  nameLabel: 'Navn',
  emailLabel: 'Email',
  phoneLabel: 'Telefon nr.',
  submitLabel: 'Gå til mødekalender',
};

const Stage = ({ mobile = false, children }) => (
  <div
    className={`${mobile ? 'ds-modal-popup-mobile-preview' : 'ds-modal-popup-preview flex items-center justify-center'} bg-[var(--color-gray-025)] p-[var(--space-ui-large-s)] rounded-[var(--radius-card)] border border-[var(--color-gray-1)]`}
  >
    {children}
  </div>
);

export const meta = {
  component: BookMeeting,
  title: 'Book Meeting',
  group: 'Overlays',
  importPath: '@ajat/design-system/BookMeeting',
  description:
    'Short lead form — name, email, phone — shown before handing a customer to an external booking calendar. It composes the shared ModalPopup shell and only validates and reports; the parent decides what submitting means. Reached from the School Selector\'s "my school is not on the list" escape hatch.',
  props: [
    ['isOpen', 'bool', 'false', 'Open state'],
    ['onClose', 'func', '—', 'Fires on X, Escape, overlay click and swipe'],
    ['onSubmit', 'func', '—', 'Fires with { name, email, phone } once validation passes'],
    ['banner', 'node', 'null', 'Banner image / node at the top'],
    ['title', 'string', "'Book a meeting'", 'Popup heading'],
    ['infoText', 'string', "''", 'Intro copy'],
    ['nameLabel', 'string', '—', 'Name field label'],
    ['emailLabel', 'string', '—', 'Email field label'],
    ['phoneLabel', 'string', '—', 'Phone field label'],
    ['submitLabel', 'string', '—', 'Submit button label'],
    ['nameErrorMessage', 'string', '—', 'Name validation message'],
    ['emailErrorMessage', 'string', '—', 'Email validation message'],
    ['phoneErrorMessage', 'string', '—', 'Phone validation message'],
    ['submitError', 'string', "''", 'Error shown above the submit button'],
    ['isSubmitting', 'bool', 'false', 'Submit button spinner'],
    ['preview', 'bool', 'false', 'Static mode — no overlay, no portal, no scroll lock'],
    ['lockScroll', 'bool', 'true', 'Lock body scroll while open'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'Lead form before an external calendar',
      code: `import BookMeeting from '@ajat/design-system/BookMeeting';

<BookMeeting
  isOpen={open}
  onClose={() => setOpen(false)}
  isSubmitting={submitting}
  onSubmit={async (values) => {
    setSubmitting(true);
    // Fail-open: a rejected lead POST must never block the booking
    await postMeetingLead(values).catch(() => {});
    window.location.href = buildMeetingCalendarUrl(values);
  }}
  {...DANISH_COPY}
/>`,
    },
  ],
};

export default function BookMeetingPage() {
  const [open, setOpen] = useState(false);

  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Live">
        <Button size="primary" variant="main" onClick={() => setOpen(true)}>Open Book Meeting</Button>
        <BookMeeting isOpen={open} onClose={() => setOpen(false)} onSubmit={() => setOpen(false)} {...COPY} />
      </DemoCard>

      <DemoCard title="Desktop — popup" surface={false}>
        <Stage><BookMeeting isOpen preview onClose={() => {}} {...COPY} /></Stage>
      </DemoCard>

      <DemoCard title="Mobile — bottom sheet" surface={false}>
        <Stage mobile><BookMeeting isOpen preview onClose={() => {}} {...COPY} /></Stage>
      </DemoCard>

      <DemoCard title="Submitting" surface={false}>
        <Stage><BookMeeting isOpen preview onClose={() => {}} isSubmitting {...COPY} /></Stage>
      </DemoCard>
    </ComponentPage>
  );
}
